/* eslint-disable no-underscore-dangle */

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Mutex } from 'async-mutex';
import { get } from 'lodash';
import QueryString from 'qs';
import { casueServerErrors } from 'src/config';
import { revokeAccount } from 'src/store/app-slice';

// Create a new mutex
const mutex = new Mutex();

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_BASE_URL,
  credentials: 'include',
  paramsSerializer: (params) => QueryString.stringify(params)
});

const exeBaseQuery = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);
  const status = get(result, 'error.status');
  console.log('exeBaseQuery', result);
  const expired = status === 401 && result.error?.data?.cause === casueServerErrors.tokenExpired;

  return { result, expired };
};

const customFetchBaseQuery = async (args, api, extraOptions) => {
  let resultLast;
  let pass = true;

  try {
    await mutex.runExclusive(async () => {
      const { result, expired } = await exeBaseQuery(args, api, extraOptions);
      resultLast = result;
      if (expired) {
        // Refresh token only if mutex is not locked
        const refreshResult = await baseQuery({ credentials: 'include', url: 'account/refreshToken' }, api, extraOptions);

        if (refreshResult.data) {
          // Retry the initial query after refreshing token
          const { result: newResult, expired: newExpired } = await exeBaseQuery(args, api, extraOptions);
          resultLast = newResult;

          // If the token is still expired after refresh, mark the process as failed
          pass = !newExpired;
        } else {
          pass = false;
        }
      }
    });
  } catch (error) {
    // Handle any unexpected errors
    console.error('Error during the API request:', error);
    pass = false;
  }

  if (!pass) {
    api.dispatch(revokeAccount(true));
  }

  return resultLast;
};

export const apiSlice = createApi({
  reducerPath: 'apiNhieuXe',
  keepUnusedDataFor: 0,
  baseQuery: customFetchBaseQuery,
  tagTypes: [
    'User',
    'Account',
    'Setting',
    'Car',
    'CarCheckAvailableBSchedule',
    'CarBrand',
    'CarBrandOptions',
    'CarModel',
    'CarModelOptions',
    'BaseFee',
    'BaseFeeOption',
    'BookingCondition',
    'BookingSchedule',
    'BookingRequest',
    'Zalo',
    'Driver'
  ],
  endpoints: () => ({})
});

export default apiSlice;
